export default __webpack_public_path__ + "static/media/Wijkkrant_W.9041130e.png";